<template>
  <v-snackbar
    v-model="show"
    :color="toastData.type === 'info' ? 'blue darken-1' : 'error'"
    :timeout="toastData.timeout"
    top
    right
  >
    <v-icon left color="white">
      {{ toastData.type === 'info' ? 'mdi-information' : 'mdi-alert' }}
    </v-icon>
    {{ toastData.message }}
    <template v-slot:action="{ attrs }">
      <v-btn text color="white" v-bind="attrs" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "ToastRedirecionamento",
  
  data() {
    return {
      show: false,
      toastData: {
        type: 'info',
        message: '',
        timeout: 5000
      }
    };
  },
  
  methods: {
    showToast({ type = 'info', message, timeout = 5000 }) {
      this.toastData = { type, message, timeout };
      this.show = true;
    },
    
    close() {
      this.show = false;
    }
  }
};
</script> 